import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
    const { login, user, error } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    if (user) return <Navigate to={user.must_change_password ? "/change-password" : "/"} replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const ok = await login(email, password);
        setLoading(false);
        if (ok) {
            toast.success("Bienvenido/a");
            nav("/");
        }
        else toast.error(error || "Credenciales inválidas");
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
            <div className="w-full max-w-sm" data-testid="login-page">
                {/* Logo EN Boreal en la parte superior */}
                <div className="flex flex-col items-center mb-10">
                    <img
                        src="/logo-boreal.png"
                        alt="EN Boreal — Espacio de Neurorrehabilitación"
                        className="h-32 w-auto mb-4 select-none"
                        draggable={false}
                        data-testid="login-logo"
                    />
                    <div className="text-xs text-muted-foreground" data-testid="Login_42_20">Espacio de Neurorrehabilitación Boreal</div>
                </div>

                <div className="mb-6 text-center">
                    <h1 className="text-2xl font-semibold tracking-tight text-foreground">Bienvenido/a</h1>
                </div>

                <form onSubmit={onSubmit} className="space-y-4">
                    <div>
                        <Label htmlFor="email" className="uppercase-label mb-1.5 block">Email</Label>
                        <Input id="email" data-testid="login-email" type="email" value={email}
                            onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div>
                        <Label htmlFor="password" className="uppercase-label mb-1.5 block">Contraseña</Label>
                        <Input id="password" data-testid="login-password" type="password" value={password}
                            onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                    {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
                    <Button type="submit" disabled={loading} data-testid="login-submit"
                        className="w-full btn-cta">
                        {loading ? "Entrando…" : "Iniciar sesión"}
                    </Button>
                </form>
            </div>
        </div>
    );
}
